<div class="certification-header" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <div class="breadcrumb-container">
      <qai-breadcrumb-list
        [items]="getBreadcrumbItems()"
      ></qai-breadcrumb-list>
    </div>
    
    <span class="certification-heading">{{ moduleStats?.name }}</span>
  
    <div class="info-container">
      <div class="call-type-container">
        <qai-label [kind]="'secondary'" [size]="'small'" [weight]="'bold'">
          <qai-icon kind="award" qaiSlot="start" />
          {{ 'reportingV2.CERTIFICATION_LABEL' | transloco }}
        </qai-label>
      </div>
      <div class="date-range-container" *ngIf="formattedStartDate || formattedEndDate">
        <qai-badge
          [shape]="'rectangle'"
          [kind]="'gray'"
          [label]="(formattedStartDate && formattedEndDate) ? (formattedStartDate + ' - ' + formattedEndDate) : (formattedStartDate || formattedEndDate)"
          class="date-badge">
        </qai-badge>
      </div>
      <div class="passing-score-container" *ngIf="moduleStats?.scoreCriteria">
        <qai-badge
          [shape]="'round'"
          [kind]="'mist-blue'"
          [label]="('reportingV2.PASSING_SCORE' | transloco) + ': ' + this.localeService.formatNumber(moduleStats!.scoreCriteria)"
          class="passing-score-badge">
        </qai-badge>
      </div>
    </div>
    
    <div class="team-selector-container" *ngIf="searchOptions.length > 1">
      <qai-label class="selector-label" kind="secondary" size="small" weight="regular">
        {{ 'reportingV2.TEAMS' | transloco }}
      </qai-label>
        <qai-multiselect
          #multiselect
          [options]="searchOptions"
          [placeholder]="'reportingV2.SEARCH_TEAMS' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [startIcon]="'search'"
          (valueChange)="onTeamChange($event)"
          [value]="selectedTeams"
          [persistSearch]="true"
          [clearButton]="clearOption"
          [selectionDisplayMode]="'single-row-truncated'"
          [visibleOptionsSelectionMode]="visibleOptionsMode"
          >
        </qai-multiselect>
    </div>
  </qai-inner-wrap>
</div>

